var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-thread-replies-skeleton bcx-all bcx-main-content"},[_c(_setup.BCXSkeleton),_vm._l((3),function(i){return _c(_setup.ThreadMessageSkeleton,{key:i})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }